import { DOCUMENT_MAX_HEIGHT, DOCUMENT_MAX_WIDTH, DOCUMENT_MIN_HEIGHT, DOCUMENT_MIN_WIDTH, DOCUMENT_QUALITY_MIN, DOCUMENT_QUALITY_TICK } from '../../_config/Consts';
import { DocumentAction, DocumentActionType } from '../_actions/DocumentActions';
import DocumentStore, { DocumentStatusTypes } from '../_stores/DocumentStore';
import Dimensions from '../../Utils/Dimensions';

const DocumentReducer = (store: DocumentStore = new DocumentStore(), action: DocumentAction): DocumentStore => {
	switch (action.type) {
		case DocumentActionType.OnChangeDesignId:
			return store.set('designId', action.value);

		case DocumentActionType.OnChangeName:
			return store.set('name', action.value);
		
		case DocumentActionType.OnChangeOffsetX: 
			return store.set('offsetX', action.value);

		case DocumentActionType.OnChangeOffsetY: 
			return store.set('offsetY', action.value);

		case DocumentActionType.OnChangeDPI:
			let dpi = action.limit ? Dimensions.calcDPI(action.value, store.get('width'), store.get('height')) : action.value;
			return store.set('dpi', dpi);

		case DocumentActionType.OnChangeQuality:
			return store.set('quality', action.value);

		case DocumentActionType.OnIncreaseQuality:
			if(store.get('quality') + DOCUMENT_QUALITY_TICK > action.maxQuality) return store.set('quality', action.maxQuality);
			return store.set('quality', store.get('quality') + DOCUMENT_QUALITY_TICK);

		case DocumentActionType.OnDecreaseQuality:
			if(store.get('quality') - DOCUMENT_QUALITY_TICK < DOCUMENT_QUALITY_MIN){
				return store.set('quality', DOCUMENT_QUALITY_MIN);
			}
			return store.set('quality', store.get('quality') - DOCUMENT_QUALITY_TICK);

		case DocumentActionType.OnChangeUnits:
			return store.set('units', action.value);
			
		case DocumentActionType.OnChangeStatus:
			return store.set('status', action.value);

		case DocumentActionType.OnChangeLockRatio:
			// Force that to true if we're attached.
			if(store.has('attachedModule') && store.get('attachedModule') != null) {
				action.value = true
			}

			return store.set('lockRatio', action.value);

		case DocumentActionType.OnChangeUseChunks:
			return store.set('useChunks', action.value)
	}

	return store;
}

export default DocumentReducer